import { AppSharedModule } from '../app-shared.module';
import { NgModule } from '@angular/core';
import { ComponentsModule } from '../components/components.module';
import { OrgaoJulgadorListaComponent } from './orgao-julgador-lista/orgao-julgador-lista.component';
import { OrgaoJulgadorEdicaoComponent } from './orgao-julgador-edicao/orgao-julgador-edicao.component';
import { OrgaoJulgadorService } from './orgao-julgador.service';
import { OrgaoJulgadorRoutingModule } from './orgao-julgador.routing';
import { OrgaoJulgadorFrmComponent } from './orgao-julgador-frm/orgao-julgador-frm.component';
import { OrgaoJulgadorVisualizacaoComponent } from './orgao-julgador-visualizacao/orgao-julgador-visualizacao.component';

@NgModule({
  imports: [AppSharedModule, ComponentsModule],
  declarations: [
    OrgaoJulgadorListaComponent,
    OrgaoJulgadorFrmComponent,
    OrgaoJulgadorEdicaoComponent,
    OrgaoJulgadorVisualizacaoComponent,
  ],
  exports: [OrgaoJulgadorRoutingModule],
  providers: [OrgaoJulgadorService],
})
export class OrgaoJulgadorModule {}
